import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Alert from 'antd/lib/alert';

@translate()
export default class PendingActionAlert extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    pendingActions: PropTypes.number.isRequired,
    isAllocation: PropTypes.bool,
  };

  getMessage() {
    const { isAllocation, pendingActions, t } = this.props;

    let entity;

    if (pendingActions === 1) {
      entity = isAllocation ? t('investícia') : t('pôžička');
    } else if (pendingActions < 5) {
      entity = isAllocation ? t('investície') : t('pôžičky');
    } else {
      entity = isAllocation ? t('investícií') : t('pôžičiek');
    }

    return `${pendingActions} ${entity} ${
      pendingActions === 1 || pendingActions > 4 ? 'si vyžaduje' : 'si vyžadujú'
    } vašu pozornosť`;
  }

  render() {
    const { pendingActions } = this.props;

    if (pendingActions === 0) {
      return <div />;
    }

    return (
      <Row around="xs">
        <Col xs={12}>
          <Alert message={this.getMessage()} type="warning" showIcon description={'\t'} />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/PendingActionAlert.js